<template>
  <div @click.stop="() => null">
    <img v-show="msg.havenew" src="../../assets/img/new.png">
    <el-button
      :disabled="(msg.IsBind == false || msg.IdentifyType === IDENTIFY_TYPE.UNKNOWN) || !hasPermission"
      :class="{ eventNone: forbidden }"
      class="distinguish-btn"
      :style="forbidden ? 'opacity: 0.6;' : ''
      "
      @click.stop="know(msg)"
    >
      {{ $t("devicecard.identification") }}
    </el-button>
    <template v-if="imgDialog">
      <el-dialog
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible.sync="imgDialog"
        class="imgDialog"
        width="50%"
        :before-close="handleClose"
      >
        <template v-for="(item, index) in imgsrcDesc">
          <div :key="index">
            <img v-if="item.Type === 'img'" class="Dialogimg" :src="item.Value">
            <div v-if="item.Type === 'txt'" class="Dialogimg txt">
              {{ item.Value }}
            </div>
          </div>
        </template>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { GetIdentifyInfo, GetUIGuideDataList, PositiveIdentify } from '@/axios/IDevice'
import { alerterror } from '@assets/common'
import { IDENTIFY_TYPE,CONFIGTYPE , APPTYPE} from '@/utils/enums'
import { getdeviceImageStatus } from '@/utils/utils'
import { isExistPermission } from '@/components/OppleAuth/index';

let timeoutHandler
export default {
  name: 'Distinguish',
  props: {
    msg: {
      type: Object,
      required: true
    },
    isParentFlash: {
      type: Boolean, //是否负责由父组件闪烁
      required: false
    }
  },
  data() {
    return {
      hasPermission: isExistPermission('ActionDevice', this.$store.state.isPassPermission),
      imgDialog: false,
      imgsrcDesc: [], // 被动识别图片描述
      stateClassSku: ['0x0200031C', '0x0200031B', '0x0200030C', '0x02000301'], //状态识别的classsku
      // noIdentificationList:[] // 禁用识别按钮
      IDENTIFY_TYPE: IDENTIFY_TYPE,
      cardFlash: false,
      identifNone:this.$t('devicecard.identifNone')
    }
  },
  computed: {
    forbidden () {
      return getdeviceImageStatus(this.msg, '0X0100', '0')
    },
    socketmodel() {
      // 比较函数 需要监听的数据
      return this.$store.state.socketmodel
    }
  },
  watch: {
    socketmodel(res) {
      // 监听socket数据
      const item = res.Result && res.Result[0]
      const deviceId = item && item.DeviceId
      const VDeviceId = item && item.VDeviceId
      // this.cardFlash  状态识别只有弹窗识别框才会闪烁  增加容错 接口数据,同步数据列表没有DeviceId ,只有VDeviceId,判断只要两者有一个相等
      const stateIdentify = item.Type === 11 && (deviceId === this.msg.DeviceId || VDeviceId === this.msg.VDeviceId)  && this.cardFlash
      const PassiveIdentify = item.Type === 3 && item.DeviceMac === this.msg.Mac
      if (PassiveIdentify || stateIdentify) {
        this.imgDialog = false;
        if (item?.Type == 11) this.flash();
        this.cardFlash = false
        this.imgsrcDesc = []
        this.handleClose()

      }
    },
    imgDialog(value) {
      clearTimeout(timeoutHandler)
      if (value) {
        timeoutHandler = setTimeout(() => {
          this.imgDialog = false
        }, 60000)
      }
    }
  },
  methods: {
    handleClose(done) {
      done  && done()
      this.cardFlash = false
      this.imgsrcDesc = []
      this.$nextTick(() => {
        let overlays = document.getElementsByClassName('v-modal');
        for (let i = 0; i < overlays.length; i++) {
          overlays[i].parentNode.removeChild(overlays[i]);
          
        }
      })
    },
    /* 页面点击识别执行的方法
         * model：设备对象
         */
    know(model) {
      if (model.IdentifyType === -1) return;

      this.doGetIdentifyInfo(model)
    },
    // getdeviceImageStatus (msg, type, value) {
    //   let result = null
    //   if (msg != null && msg.StatusInfo != null) {
    //     msg.StatusInfo.forEach((model) => {
    //       if (
           
    //         model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 &&
    //         (msg.ChildId != 65535 ? model.ChannelId == msg.ChildId : true) &&
    //         (msg.ChildId == 65535
    //           ? msg.ClassSku.toUpperCase() != '0X001C3003'
    //           : true)
    //       ) {
    //         if (model.Value == value || model.Value1 == value) {
    //           result = true
    //         } else {
    //           result = false
    //         }
    //       }
    //     })
    //   }
    //   return result
    // },
    /* 查询设备认领方式
   * model：设备对象
   */
    doGetIdentifyInfo(model) {
      // 查询设备认领方式
      let para = { classSku: model.ClassSku, channelId: model.ChannelId }
      GetIdentifyInfo(para, this.functionDoGetIdentifyInfo, model)
      para = null
    },
    /* 获得设备的识别方式接口返回数据处理
   * rs：接口原始数据包
   * para：传递的参数
   * model：设备对象
   */
    functionDoGetIdentifyInfo(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // 去识别
        this.doPositiveIdentify(rs.Result, model)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 去识别设备
   * result：接口原始数据包
   * model：设备对象
   */
    doPositiveIdentify(result, model) {
      if (result != null && (result.IdentifyType == 1 || result.IdentifyType == 2)) {
        // 被动识别
        // var _imgurl = "";
        // if (model.ClassSku == "0x02000308") {
        //   _imgurl = "/static/device/identify/nonev2.png";
        // } else if (
        //   result.IntroImage == "" ||
        //   result.IntroImage == null ||
        //   result.IntroImage.indexOf("http") != -1
        // ) {
        //   _imgurl = "/static/device/identify/none.png";
        // } else {
        //   _imgurl = "/static/device/identify/" + result["IntroImage"];
        // }

        // //model.ClassSku

        const para = {
          type: CONFIGTYPE.passivity,
          classSku: model.ClassSku,
          appType: APPTYPE.web
        }
        this.imgsrcDesc = []
        GetUIGuideDataList(para, this.functionGetUIGuideDataList, model)
      } else if (model != null) {
        let para = {
          mac: model.Mac,
          deviceId: model.VDeviceId,
          channelId: model.ChildId
        }
        PositiveIdentify(para, this.functionDoPositiveIdentify, model)
        para = null
      }
    },
    /**
     * 获取引导页资源
     * @para {1 | 2 } type 1:SSid 更换引导; 2:被动识别
     * @para {1 | 2 | 3 | 4 } appType app类型，1:欧普智慧灯光;2:欧普智能家庭;3:欧普智家;4:商照
     * @returns {Promise} request promise
     */
    functionGetUIGuideDataList(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        const array = ['0x02000306', '0x02000307', '0x02000308']

        const arrIndex = array.findIndex(item => {
          return item === model.ClassSku
        })


        if (arrIndex !== -1) {
          this.imgsrcDesc = [{
            Type: 'img', Value: rs?.Result[0]?.Value
          }, {
            Type: 'txt',
            Value: this.$t('devicecard.identif1')
          }, {
            Type: 'txt',
            Value: this.$t('devicecard.identif3')
          }]
          this.cardFlash = true
          this.imgDialog = true
          return
        } else if (model.ClassSku == '0x02000202') {
          this.imgsrcDesc = [{
            Type: 'img', Value: rs?.Result[0]?.Value
          }, {
            Type: 'txt',
            Value: this.$t('devicecard.identif2')
          }]
          this.cardFlash = true
          this.imgDialog = true
          return
        }

        if (rs.Result.length > 0) {
          this.imgsrcDesc = rs.Result
          this.cardFlash = true
          this.imgDialog = true
        } else {
          this.imgsrcDesc = [{
            // Type: 'img', Value: '../../static/device/identify/none.png'
            Type: 'img', Value: require('@static/device/identify/none.png')
          }, {
            Type: 'txt',
            Value: this.identifNone
          }]
          this.cardFlash = true
          this.imgDialog = true
        }
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 识别设备处理方法
   * rs：接口返回的原始数据包
   * para：向接口传递的参数
   * model：当前识别的设备对象
   */
    functionDoPositiveIdentify(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {

        // model.isflicker = true
        // setTimeout(() => {
        //   model.isflicker = false
        // }, 2000)
        this.flash();
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    // 闪烁
    flash() {
      // 判断父级是否有闪烁方法
      if (this.isParentFlash) {
        this.$emit('flash', this.msg)
        return
      }
      this.msg.isflicker = true;
      setTimeout(() => {
        this.msg.isflicker = false;
      }, 2000);

    }
  }
}
</script>

<style scoped>
.txt {
  text-align: left;
  display: block;
}
</style>
